import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import QuizTaking from '../components/QuizTaking';
import QuizResults from '../components/QuizResults';
import api from '../api';

const QuizTakingPage = () => {
    const { quizId } = useParams();
    const navigate = useNavigate();
    const [quiz, setQuiz] = useState(null);
    const [quizAttempt, setQuizAttempt] = useState(null);
    const [showResults, setShowResults] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (quizId) {
            startQuiz();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quizId]);

    const startQuiz = async () => {
        try {
            setLoading(true);
            setError('');

            // First, fetch the quiz details
            const quizRes = await api.get(`/quizzes/${quizId}`);
            setQuiz(quizRes.data);

            // Then, start the attempt
            const attemptRes = await api.post(`/quizzes/${quizId}/attempt`);
            setQuizAttempt(attemptRes.data);
        } catch (error) {
            console.error('Error starting quiz:', error);
            setError(
                error.response?.data?.errors?.[0]?.msg ||
                error.response?.data?.msg ||
                'Không thể bắt đầu bài tập. Vui lòng thử lại.'
            );
        } finally {
            setLoading(false);
        }
    };

    const finishQuiz = () => {
        // Navigate back to the previous page or quiz list
        navigate(-1);
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto"></div>
                    <p className="mt-4 text-lg font-semibold text-gray-700">Đang tải bài tập...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4">
                <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
                    <div className="text-center">
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                            <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 mb-2">Lỗi</h2>
                        <p className="text-gray-600 mb-6">{error}</p>
                        <button
                            onClick={() => navigate(-1)}
                            className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all"
                        >
                            Quay lại
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    if (showResults) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 py-8">
                <div className="max-w-6xl mx-auto px-4">
                    <QuizResults
                        quiz={showResults}
                        onBack={() => {
                            setShowResults(null);
                            navigate(-1);
                        }}
                    />
                </div>
            </div>
        );
    }

    if (quiz && quizAttempt) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100">
                <QuizTaking
                    quiz={quiz}
                    attempt={quizAttempt}
                    onFinish={finishQuiz}
                />
            </div>
        );
    }

    return null;
};

export default QuizTakingPage;
